var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questionnaires"},[_c('CompleteDialog',{ref:"completeDialog"}),(_vm.loading)?_c('div',{staticClass:"mt-10 loading-container"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }